// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__301_6","ranges":"BmiRanges_ranges__3MgF6"};